function getSelectedVariant(productData, selectedVariantId) {
    const { variantsData } = productData;

    if (!variantsData || !selectedVariantId) return null;

    const selectedVariant = variantsData.find((variant) => variant.id === selectedVariantId);

    return selectedVariant || null;
}

export { getSelectedVariant };
